import React from 'react';

import IndexPage from '../templates/IndexPage';
// FIXME: limit value is still hardcoded in the GraphQL query below
import limit from '../components/limit';

class BlogIndex extends React.Component {
  render() {
    const hasMorePrevious =
      this.props.data.allMarkdownRemark.edges.length > limit;

    return (
      <IndexPage
        {...{
          ...this.props,
          pathContext: {
            currentPage: 0,
            hasMorePrevious,
            hasMoreRecent: false,
          },
        }}
      />
    );
  }
}

export default BlogIndex;

export const pageQuery = graphql`
  query IndexQuery {
    site {
      siteMetadata {
        title
      }
    }

    allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
      filter: { frontmatter: { isDraft: { ne: true } } }
      limit: 10
    ) {
      edges {
        node {
          html
          fields {
            slug
          }
          frontmatter {
            date(formatString: "DD MMMM, YYYY")
            title
            tldr
            topImg {
              publicURL
            }
          }
        }
      }
    }
  }
`;



// WEBPACK FOOTER //
// ./src/pages/index.js